module.exports = __webpack_public_path__ + "media/images/author/author-4-f0e9e5b5c102fe3e66fb68d4606f4e4b.jpg";